<!--
 * @Description:  工作台
 * @Author: yameier
 * @Date: 2024-05-20 15:43:45
 * @FilePath: \pta-ui3.0\example\main\src\views\
 -->
<template>
  <div class="home_box">
    <!-- Loading 遮罩层 -->
    <div v-if="loading" class="loading-overlay">
      <div class="loading-content">
        <el-icon class="is-loading loading-icon">
          <Loading />
        </el-icon>
        <p class="loading-text">正在加载组织和应用信息...</p>
      </div>
    </div>

    <!--    <Nav></Nav>-->
    <div class="home_left h-full m_r_20">
      <div class="home_left_info bg-white w-full flex items-center relative">
        <img
          class="avatar-img"
          :src="
            userInfo.photoTemp
              ? userInfo.photoTemp
              : 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
          "
          alt=""
        />
        <div class="h_info">
          <p class="p1">{{ userInfo.cnName }}</p>
          <p class="p2">{{ currentTenant.name || "" }}</p>
          <p class="p3">{{ currentTenant.slogan }}</p>
        </div>
        <div class="ab_change_btn absolute" v-if="tenantList.length > 1">
          <el-popover
            :width="300"
            ref="myPopover"
            trigger="click"
            popper-style="box-shadow: rgb(14 18 22 / 35%) 0px 10px 38px -10px, rgb(14 18 22 / 20%) 0px 10px 20px -15px; padding: 20px;"
          >
            <template #reference>
              <div
                class="h-full w-full flex items-center justify-center"
                v-ripple:color="'rgba(169,169,169,0.3)'"
              >
                切换组织
                <svg-icon icon-class="change"></svg-icon>
              </div>
            </template>
            <template #default>
              <div
                class="overflow-hidden"
                v-if="tenantList.length > 8"
                style="height: 400px"
              >
                <el-scrollbar>
                  <div :style="{ height: '420px' }">
                    <div
                      class="change_tenant flex items-center justify-between"
                      v-for="item in tenantList"
                      @click.native="changeTenant(item)"
                    >
                      <div class="flex items-center flex-shrink-0">
                        <el-avatar
                          :size="30"
                          :src="
                            item.photoTemp
                              ? item.photoTemp
                              : 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
                          "
                        />
                        <p class="ml-2 truncate" style="width: 160px">
                          {{ item.name }}
                        </p>
                      </div>
                      <div
                        class="change_btn flex items-center justify-center"
                        v-ripple:color="'rgba(169,169,169,0.3)'"
                        v-if="item.valid === '0'"
                      >
                        <svg-icon icon-class="change"></svg-icon>
                      </div>
                      <div class="flex-shrink-0" v-if="item.valid === '1'">
                        已禁用
                      </div>
                    </div>
                  </div>
                </el-scrollbar>
              </div>
              <div class="overflow-hidden" v-else>
                <div
                  class="change_tenant flex items-center justify-between"
                  v-for="item in tenantList"
                  @click.native="changeTenant(item)"
                >
                  <div class="flex items-center flex-shrink-0">
                    <el-avatar
                      :size="30"
                      :src="
                        item.photoTemp
                          ? item.photoTemp
                          : 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
                      "
                    />
                    <p class="ml-2 truncate" style="width: 160px">
                      {{ item.name }}
                    </p>
                  </div>

                  <div
                    class="change_btn flex items-center justify-center"
                    v-ripple:color="'rgba(169,169,169,0.3)'"
                    v-if="item.valid === '0'"
                  >
                    <svg-icon icon-class="change"></svg-icon>
                  </div>
                  <div class="flex-shrink-0" v-if="item.valid === '1'">
                    已禁用
                  </div>
                </div>
              </div>
            </template>
          </el-popover>
        </div>
      </div>
      <div class="home_left_app m_t_20 w-full bg-white p20 relative">
        <div
          class="absolute h-full w-full home-a"
          @click="homeCLick"
          v-if="orgInfo.valid === '1'"
        ></div>
        <com-about
          @isApp="homeIsApp"
          @closeApp="closeApp"
          :tenantList="appList"
          ref="comAbourRef"
        ></com-about>
      </div>
    </div>
    <div class="home_right h-full bg-white relative" style="height: calc(100%)">
      <div
        class="absolute h-full w-full home-b"
        @click="homeCLick"
        v-if="orgInfo.valid === '1'"
      ></div>
      <informationList
        title="热门资讯"
        ref="informationListRef"
        :isAll="false"
      ></informationList>
    </div>

    <!--    &lt;!&ndash;  切换组织信息  &ndash;&gt;-->
    <!--    <div class="flex items-center content-nav-top">-->
    <!--      <div class="c_fff f_14 m_r_20" v-if="!tenantList.length"> 企业未认证</div>-->
    <!--      <div v-if="tenantList.length">-->
    <!--        <el-dropdown @command='handleOptins($event)'>-->
    <!--              <span class="el-dropdown-link  mr-6 flex flex-center">-->
    <!--                <div class="c_fff">{{ chooseTenantName }}</div>-->
    <!--                <i class="xiala"></i>-->
    <!--              </span>-->
    <!--          <template #dropdown>-->
    <!--            <el-dropdown-menu>-->
    <!--              <el-dropdown-item v-for="(item,index) in tenantList" :key="index">{{-->
    <!--                  item.orgName-->
    <!--                }}-->
    <!--              </el-dropdown-item>-->
    <!--            </el-dropdown-menu>-->
    <!--          </template>-->
    <!--        </el-dropdown>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script>
// 主应用中监听sessionStorage变化
window.addEventListener('storage', (e) => {
  if (e.key === 'appid' && e.newValue) {
    actions.setGlobalState({
      appid: e.newValue
    });
  }
});

import actions from "@/action";
import store from "@/store";
import {
  Search,
  DArrowLeft,
  DArrowRight,
  Loading,
} from "@element-plus/icons-vue";
import { appsData, dynamicRegisterApps } from "@/utils/registerMicroAppsConfig";
import { getUserInfoByToken } from "@/api/UserInfo";
import { mapMutations, mapState, useStore } from "vuex";
import {
  addUserVisitRecord,
  getApi,
  getAppInfo,
  getAppList,
  getAppQuickFuncListApi,
  getexchangeForToken,
  getMenuPrv,
  getOrgInfoByUser,
  getOrgList,
  getUserInfo,
  noticeCount,
} from "@/api";
import comAbout from "@/views/About.vue";
import informationList from "@/views/User/information.vue";
import Nav from "@/components/Nav.vue";
import { setLocal } from "@/utils/formExtend";
import SvgIcon from "@/components/svgIcon/SvgIcon.vue";
import { nextTick } from "vue";
import { updateTopic } from "@/utils/common";
import appMixin from "@/mixins/appMixin.js";
export default {
  name: "qiankunMenu",
  mixins: [appMixin],
  components: {
    SvgIcon,
    comAbout,
    informationList,
    Nav,
    Loading,
    DArrowLeft,
    DArrowRight,
  },
  computed: {
    ...mapState(["userInfo", "orgInfo", "appInfo", "funList"]),
    // 定义 SearchIcon 变量为 Search 图标组件
    SearchIcon() {
      return Search;
    },
    bangbotEntryStyle() {
      return {
        transform: `translate3d(${this.bangbotEntryPosition.x}px, ${this.bangbotEntryPosition.y}px, 0)`,
      };
    },
    bangbotEntryTabStyle() {
      return {
        top: `${this.bangbotEntryPosition.y}px`,
      };
    },
    bangbotBubbleSideClass() {
      return this.bangbotEntryPosition.x > window.innerWidth / 2
        ? "is-left"
        : "is-right";
    },
  },
  data() {
    return {
      loading: false, // 页面加载状态
      bangbotEntryReady: false,
      bangbotEntryPosition: {
        x: 0,
        y: 0,
      },
      bangbotDrag: {
        active: false,
        moved: false,
        startX: 0,
        startY: 0,
        originX: 0,
        originY: 0,
      },
      bangbotSuppressClick: false,
      bangbotSuppressTimer: null,
      bangbotEntryCollapsed: false,
      bangbotEntryCollapsedSide: "right",
    };
  },
  mounted() {
    this.hideBangbotEntry();
    this.isSuccess();
    this.updateNoice();
    this.getInfo();
    this.initBangbotEntry();
    window.addEventListener("resize", this.handleBangbotResize);
   },
  beforeUnmount() {
    this.teardownBangbotDrag();
    window.removeEventListener("resize", this.handleBangbotResize);
    if (this.bangbotSuppressTimer) {
      window.clearTimeout(this.bangbotSuppressTimer);
      this.bangbotSuppressTimer = null;
    }
  },
  methods: {
    ...mapMutations(["SET_BANGBOT_VISIBLE"]),
    showBangbotEntry() {
      this.SET_BANGBOT_VISIBLE(true);
    },
    hideBangbotEntry() {
      this.SET_BANGBOT_VISIBLE(false);
    },
    getBangbotEntryMetrics() {
      return {
        width: 92,
        height: 104,
        gap: 24,
        minTop: 120,
      };
    },
    getBangbotEntryTabMetrics() {
      return {
        width: 30,
        height: 76,
        edgeGap: 0,
      };
    },
    clampBangbotValue(value, min, max) {
      return Math.min(Math.max(value, min), max);
    },
    getBangbotVerticalBounds(height) {
      const { gap, minTop } = this.getBangbotEntryMetrics();
      return {
        minY: minTop,
        maxY: Math.max(minTop, window.innerHeight - height - gap),
      };
    },
    getSavedBangbotPosition() {
      try {
        const raw = localStorage.getItem("bangbot-float-position");
        if (!raw) {
          return null;
        }

        const parsed = JSON.parse(raw);
        if (
          typeof parsed?.x === "number" &&
          Number.isFinite(parsed.x) &&
          typeof parsed?.y === "number" &&
          Number.isFinite(parsed.y)
        ) {
          return {
            x: parsed.x,
            y: parsed.y,
            collapsed: Boolean(parsed.collapsed),
            side: parsed.side === "left" ? "left" : "right",
          };
        }
      } catch (error) {
        console.error("读取 BangBot 入口位置失败:", error);
      }

      return null;
    },
    saveBangbotPosition() {
      try {
        localStorage.setItem(
          "bangbot-float-position",
          JSON.stringify({
            ...this.bangbotEntryPosition,
            collapsed: this.bangbotEntryCollapsed,
            side: this.bangbotEntryCollapsedSide,
          })
        );
      } catch (error) {
        console.error("保存 BangBot 入口位置失败:", error);
      }
    },
    getNormalizedBangbotPosition(position = {}) {
      const { width, height, gap, minTop } = this.getBangbotEntryMetrics();
      const maxX = Math.max(gap, window.innerWidth - width - gap);
      const maxY = Math.max(minTop, window.innerHeight - height - gap);
      const minX = gap;
      const minY = minTop;

      let x = this.clampBangbotValue(Number(position.x || 0), minX, maxX);
      let y = this.clampBangbotValue(Number(position.y || 0), minY, maxY);

      return { x, y };
    },
    getNormalizedBangbotTabPosition(position = {}) {
      const { height } = this.getBangbotEntryTabMetrics();
      const { minY, maxY } = this.getBangbotVerticalBounds(height);

      return {
        y: this.clampBangbotValue(Number(position.y || 0), minY, maxY),
      };
    },
    initBangbotEntry() {
      const { width, gap, minTop } = this.getBangbotEntryMetrics();
      const defaultPosition = {
        x: Math.max(gap, window.innerWidth - width - 32),
        y: Math.max(minTop, 150),
      };
      const savedPosition = this.getSavedBangbotPosition();
      const nextPosition = savedPosition || defaultPosition;

      this.bangbotEntryCollapsed = Boolean(savedPosition?.collapsed);
      this.bangbotEntryCollapsedSide = savedPosition?.side || "right";
      this.bangbotEntryPosition = this.bangbotEntryCollapsed
        ? {
            ...defaultPosition,
            ...this.getNormalizedBangbotTabPosition(nextPosition),
          }
        : this.getNormalizedBangbotPosition(nextPosition);
      this.bangbotEntryReady = true;
      this.saveBangbotPosition();
    },
    handleBangbotResize() {
      this.bangbotEntryPosition = this.bangbotEntryCollapsed
        ? {
            ...this.bangbotEntryPosition,
            ...this.getNormalizedBangbotTabPosition(this.bangbotEntryPosition),
          }
        : this.getNormalizedBangbotPosition(this.bangbotEntryPosition);
      this.saveBangbotPosition();
    },
    startBangbotDrag(event) {
      if (event.button !== 0) {
        return;
      }

      this.bangbotDrag = {
        active: true,
        moved: false,
        startX: event.clientX,
        startY: event.clientY,
        originX: this.bangbotEntryPosition.x,
        originY: this.bangbotEntryPosition.y,
      };

      document.addEventListener("mousemove", this.handleBangbotDrag);
      document.addEventListener("mouseup", this.stopBangbotDrag);
    },
    handleBangbotDrag(event) {
      if (!this.bangbotDrag.active) {
        return;
      }

      const deltaX = event.clientX - this.bangbotDrag.startX;
      const deltaY = event.clientY - this.bangbotDrag.startY;

      if (!this.bangbotDrag.moved) {
        const distance = Math.abs(deltaX) + Math.abs(deltaY);
        if (distance > 4) {
          this.bangbotDrag.moved = true;
        }
      }

      this.bangbotEntryPosition = {
        x: this.bangbotDrag.originX + deltaX,
        y: this.bangbotDrag.originY + deltaY,
      };
    },
    stopBangbotDrag() {
      if (!this.bangbotDrag.active) {
        return;
      }

      const { width } = this.getBangbotEntryMetrics();
      const { x, y } = this.bangbotEntryPosition;
      const collapseThreshold = width * 0.35;
      const collapseLeft = x <= -collapseThreshold;
      const collapseRight = x >= window.innerWidth - width + collapseThreshold;

      if (collapseLeft || collapseRight) {
        this.bangbotEntryCollapsed = true;
        this.bangbotEntryCollapsedSide = collapseLeft ? "left" : "right";
        this.bangbotEntryPosition = {
          ...this.bangbotEntryPosition,
          ...this.getNormalizedBangbotTabPosition({ y }),
        };
      } else {
        this.bangbotEntryCollapsed = false;
        this.bangbotEntryPosition = this.getNormalizedBangbotPosition(
          this.bangbotEntryPosition
        );
      }
      this.saveBangbotPosition();

      if (this.bangbotDrag.moved) {
        this.bangbotSuppressClick = true;
        if (this.bangbotSuppressTimer) {
          window.clearTimeout(this.bangbotSuppressTimer);
        }
        this.bangbotSuppressTimer = window.setTimeout(() => {
          this.bangbotSuppressClick = false;
          this.bangbotSuppressTimer = null;
        }, 160);
      }

      this.teardownBangbotDrag();
    },
    teardownBangbotDrag() {
      document.removeEventListener("mousemove", this.handleBangbotDrag);
      document.removeEventListener("mouseup", this.stopBangbotDrag);
      this.bangbotDrag = {
        active: false,
        moved: false,
        startX: 0,
        startY: 0,
        originX: this.bangbotEntryPosition.x,
        originY: this.bangbotEntryPosition.y,
      };
    },
    restoreBangbotEntry() {
      const { width, gap } = this.getBangbotEntryMetrics();
      const restoreX =
        this.bangbotEntryCollapsedSide === "left"
          ? gap
          : Math.max(gap, window.innerWidth - width - gap);

      this.bangbotEntryCollapsed = false;
      this.bangbotEntryPosition = this.getNormalizedBangbotPosition({
        x: restoreX,
        y: this.bangbotEntryPosition.y,
      });
      this.saveBangbotPosition();
    },
    openBangbot() {
      if (this.bangbotSuppressClick) {
        return;
      }

      const bangbotApps = appsData.filter((item) => item.activeRule === "/bangbotUi");
      dynamicRegisterApps(bangbotApps);
      sessionStorage.setItem("bangbot:return-path", this.$route.fullPath || "/app");
      this.$router.push("/bangbotUi/chat");
    },
    homeCLick(e) {
      if (this.orgInfo.valid === "1") {
        this.$message.warning("组织已被禁用，该功能不可用");
        e.stopPropagation();
      }
    },
    // 更新通知消息
    updateNoice() {
      let params = {
        orgCode: this.orgInfo.orgCode,
        appId: this.appInfo.appId,
      };
      noticeCount(params).then((res) => {
        if (res.code === 200) {
          let data = res.data || 0;
          this.SET_NOICENUMBER(data);
        }
      });
    },
    // 获取用户信息
    jumpTo() {
      this.$router.push({ path: "/informationList" });
    },
    /**
     * 获取应用列表信息
     * @param val
     */
    async getNewToken(val) {
      try {
        this.hideBangbotEntry();
        // await getexchangeForToken(val.orgCode).then(item => {
        //   const token = item.data.token
        //   setLocal('token', token, 1000 * 60 * 60)
        // })
        const res = await getAppList({ tenantId: val.tenantId });
        let data = (res.data || []).map((obj) => ({ ...obj, show: false }));
        this.appList = data;
        const hasAutoJumped = await this.checkAutoJump();
        if (!hasAutoJumped) {
          this.loading = false;
          this.showBangbotEntry();
        }
      } catch (error) {
        console.error("获取应用列表失败:", error);
        this.appList = [];
        this.loading = false;
        this.showBangbotEntry();
      }
    },
    getAppQuickFuncList(id) {
      getAppQuickFuncListApi(id).then((res) => {
        this.shortcutKeyList = res.data || [];
        this.SET_FUNLIST(res.data || []);
      });
    },
    // 选择app
    homeIsApp(row) {
      if (this.orgInfo.valid === "1") {
        this.$message.warning("组织已被禁用，该功能不可用");
        return false;
      }
      return this.isApp(row);
    },

  
    // 关闭app
    closeApp() {
      this.appList.forEach((item) => {
        item.show = false;
      });
    },
    async isSuccess(type = "") {
      try {
        this.getTreeList();
        this.$refs.informationListRef.getList();
        this.$refs.informationListRef.getOrgInfoCategoryList();
      } catch (error) {
        console.error("初始化失败:", error);
        this.loading = false;
        this.showBangbotEntry();
      }
    },
    // 获取工作台组织列表
    getTreeList() {
      this.loading = true;
      getOrgList()
        .then((res) => {
          if (res.code == 200) {
            this.tenantList = res.data || [];
            if (this.tenantList.length) {
              if (this.orgInfo.orgCode) {
                this.currentTenant = this.tenantList.filter(
                  (item) => item.orgCode === this.orgInfo.orgCode
                )[0];
              } else {
                this.currentTenant = this.tenantList[0];
              }
              sessionStorage.setItem("orgFullName", this.currentTenant.name);
              this.SET_ORGINFO(this.currentTenant);
              if (this.menuList && this.menuList.length > 0) {
                const firstMenu = this.menuList[0];
                if (
                  firstMenu &&
                  firstMenu.children &&
                  firstMenu.children.length > 0
                ) {
                  sessionStorage.setItem(
                    "menuList",
                    JSON.stringify(firstMenu.children[0])
                  );
                  localStorage.setItem(
                    "menuList",
                    JSON.stringify(firstMenu.children[0])
                  );
                } else if (firstMenu) {
                  sessionStorage.setItem("menuList", JSON.stringify(firstMenu));
                  localStorage.setItem("menuList", JSON.stringify(firstMenu));
                }
              }
              this.getNewToken(this.currentTenant);
            } else {
              this.loading = false;
              this.showBangbotEntry();
            }
          }
        })
        .catch((error) => {
          console.error("获取组织列表失败:", error);
          this.loading = false;
          this.showBangbotEntry();
        });
    },

    /* 调用获取租户列表的list */

    // 获取应用列表信息
    getAppInfoApi() {
      getAppInfo(thixs.chooseTenant).then((res) => {
        this.appList = res.data || [];
        /*
         *  获取应用信息，如果应用不存在直接添加应用
         * */
        // if (!this.appList.length) {
        //   this.$router.push({path: "/additionInfo", query: {active: 3}})
        //   return
        // }
        /* 新增一个逻辑，如果列表只有一个直接跳进去  */
        // if (this.appList.length === 1) {
        //   this.$nextTick(() => {
        //     this.$refs.comAbourRef.chooseApp(this.appList[0])
        //   })
        // }
      });
    },
    getInfo() {
      getUserInfo().then((res) => {
        if (res.code === 200) {
          store.commit("SET_USERMANAGE", res.data.sysUser);
        }
      });
    },
    // getInfo(){
    //   //sessionStorage.getItem('name')
    //   getUserInfo({username:localStorage.getItem('name')}).then(res=>{
    //     this.userAvatar = res.data.sysUser.photo ?  process.env.VUE_APP_URL_IMG  + res.data.sysUser.photo : ''
    //   })
    // },
    goHome(text) {
      this.$emit("goHome", text);
    },
    handleOptins(text) {
      this.$emit("handleOptins", text);
    },
    navigatorTo(row, id, groupId) {
      let to = row.path;
      this.$router.push(to);
    },

    // 检查是否需要自动跳转到应用
    async checkAutoJump() {
      if (this.$route.query.page === "1") {
        return false;
      }
      // 检查条件：只有一个组织且该组织只有一个应用
      if (this.tenantList.length === 1 && this.appList.length === 1) {
        const singleApp = this.appList[0];
        // 检查应用是否可用
        if (singleApp.valid === "1") {
          this.$message.warning("唯一的应用已被禁用，无法自动进入");
          return false;
        }
        const jumpSuccess = await this.homeIsApp(singleApp);
        if (jumpSuccess) {
          this.showBangbotEntry();
          return true;
        }
        return false;
      }
      return false;
    },
  },
};
</script>
<style>
.el-image {
  height: 0;
}
</style>

<style lang="less" scoped>
.home_box {
  height: 100%;
  width: 100%;
  display: flex;
  position: relative;

  .home_left {
    width: 50%;

    .home_left_info {
      padding: 20px 30px;
      border-radius: 8px;
      border: 1px solid #e6ebf1;

      .h_info {
        margin-left: 28px;
        display: inline-block;
        width: calc(100% - 220px);

        .p1 {
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: bold;
          font-size: 20px;
          color: #000000;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }

        .p2 {
          margin-top: 10px;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: bold;
          font-size: 16px;
          color: #333333;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }

        .p3 {
          height: 21px;
          margin-top: 6px;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 14px;
          color: #999999;
          font-style: normal;
          text-transform: none;
          white-space: nowrap; /* 不换行 */
          overflow: hidden; /* 超出部分隐藏 */
          text-overflow: ellipsis; /* 超出部分显示省略号 */
          //width: 200px;        /* 设置宽度，根据实际需要调整 */
        }
      }
    }

    .home_left_app {
      height: calc(100% - 157px);
      border-radius: 8px;
      border: 1px solid #e6ebf1;
    }
  }

  .home_right {
    width: calc(50% - 20px);
    border-radius: 8px;
    border: 1px solid #e6ebf1;
    padding: 2px;
  }

  .ab_change_btn {
    top: 50%;
    margin-top: -7px;
    right: 20px;
    border-radius: 10px;
    width: 100px;
    height: 34px;
    cursor: pointer;

    & > div {
      border-radius: 10px;
    }

    .svg-icon {
      height: 14px;
      width: 14px;
      margin-left: 5px;
    }
  }

  .ab_change_btn:hover {
    background: #edeff7;
  }
}

.bangbot-entry {
  width: 92px;
  height: 104px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 120;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  box-shadow: none;
  cursor: grab;
  user-select: none;
  opacity: 0;
  transition:
    transform 0.2s ease,
    opacity 0.2s ease;

  &.is-ready {
    opacity: 1;
  }

  &.is-dragging {
    cursor: grabbing;
    transition: none;
  }
}

.bangbot-entry__badge {
  width: 14px;
  height: 14px;
  position: absolute;
  top: 0;
  left: 50%;
  z-index: 2;
  border: 2px solid #ffffff;
  border-radius: 50%;
  background: #41af0a;
  box-shadow: 0 6px 12px rgba(65, 175, 10, 0.28);
  transform: translateX(-50%);
}

.bangbot-entry__icon,
.bangbot-entry__bubble {
  position: relative;
  z-index: 1;
  pointer-events: none;
}

.bangbot-entry__icon {
  width: 92px;
  height: 104px;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  .svg-icon {
    width: 92px;
    height: 104px;
    filter: drop-shadow(0 12px 24px rgba(33, 70, 232, 0.22));
    transition: transform 0.2s ease;
  }
}

.bangbot-entry__bubble {
  min-width: 132px;
  position: absolute;
  top: 16px;
  padding: 12px 22px;
  border-radius: 20px;
  background: #dfe5ff;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 500;
  font-size: 16px;
  line-height: 1;
  color: #3b4351;
  white-space: nowrap;
  opacity: 0;
  transition:
    opacity 0.2s ease,
    transform 0.2s ease;
}

.bangbot-entry__bubble.is-right {
  left: calc(100% - 4px);
  transform: translateX(-8px);
}

.bangbot-entry__bubble.is-left {
  right: calc(100% - 4px);
  transform: translateX(8px);
}

.bangbot-entry:hover .bangbot-entry__bubble,
.bangbot-entry:focus-visible .bangbot-entry__bubble {
  opacity: 1;
}

.bangbot-entry:hover .bangbot-entry__icon .svg-icon,
.bangbot-entry:focus-visible .bangbot-entry__icon .svg-icon {
  transform: translateY(-2px) scale(1.02);
}

.bangbot-entry:hover .bangbot-entry__bubble.is-right,
.bangbot-entry:focus-visible .bangbot-entry__bubble.is-right {
  transform: translateX(0);
}

.bangbot-entry:hover .bangbot-entry__bubble.is-left,
.bangbot-entry:focus-visible .bangbot-entry__bubble.is-left {
  transform: translateX(0);
}

.bangbot-entry.is-dragging .bangbot-entry__bubble {
  opacity: 0 !important;
}

.bangbot-entry-tab {
  width: 30px;
  height: 76px;
  position: fixed;
  z-index: 120;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: linear-gradient(180deg, #5e84ff 0%, #3157f6 100%);
  color: #ffffff;
  cursor: pointer;
  box-shadow: 0 10px 24px rgba(33, 70, 232, 0.22);
  transition:
    transform 0.2s ease,
    opacity 0.2s ease;

  &.is-left {
    left: 0;
    border-radius: 0 18px 18px 0;
  }

  &.is-right {
    right: 0;
    border-radius: 18px 0 0 18px;
  }

  &:hover {
    transform: scale(1.04);
  }

  .el-icon {
    font-size: 18px;
    font-weight: bold;
  }
}

.change_tenant {
  padding: 10px 5px;
  cursor: pointer;
}

.change_tenant:hover {
  background-color: var(--el-menu-hover-bg-color);
}

.change_btn {
  border-radius: 50%;
  width: 14px;
  height: 14px;
  .svg-icon {
    height: 50px;
    width: 50px;
  }
}

.avatar-img {
  height: 96px;
  width: 96px;
  display: inline-block;
  border-radius: 50%;
}

.home-a {
  z-index: 2;
  background: rgba(0, 0, 0, 0.2);
  top: 0;
  left: 0;
}

.home-b {
  z-index: 100;
  background: rgba(0, 0, 0, 0.2);
  top: 0;
  left: 0;
}

.bg-gray-100 {
  filter: grayscale(100%);
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  -webkit-filter: grayscale(1);
}

/* Loading 样式 */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.loading-icon {
  font-size: 32px;
  color: #409eff;
}

.loading-text {
  font-size: 16px;
  color: #666;
  margin: 0;
}
</style>
